// Constnts for the default colors and thresholds on the heat chart
const LOW_COLOR_MIN = [25, 25, 255, 0.8];
const LOW_COLOR_MID = [25, 128, 255, 0.8];
const MID_COLOR = [180, 180, 180, 0.8];
const HIGH_COLOR_MID = [255, 128, 25, 0.8];
const HIGH_COLOR_MAX = [255, 25, 25, 0.8];

const LOW_COLOR_MIN_THRESH = -0.4;
const LOW_COLOR_MID_THRESH = -0.2;
const MID_COLOR_THRESH = 0.0;
const HIGH_COLOR_MID_THRESH = 0.1;
const HIGH_COLOR_MAX_THRESH = 0.2;

export const DEFAULT_COLOR_SCALE_DATA = [
  [LOW_COLOR_MIN_THRESH, LOW_COLOR_MIN],
  [LOW_COLOR_MID_THRESH, LOW_COLOR_MID],
  [MID_COLOR_THRESH, MID_COLOR],
  [HIGH_COLOR_MID_THRESH, HIGH_COLOR_MID],
  [HIGH_COLOR_MAX_THRESH, HIGH_COLOR_MAX],
];

// Constants for the default names for metrics/calcs on the frontend
export const PCT_DIFF_FROM_AVG_SLICE_TEXT = "% Difference from average - Slice";
export const PCT_DIFF_FROM_AVG_TIME_TEXT = "% Difference from average - Time";
export const PCT_DIFF_FROM_BENCHMARK_TEXT = "% Difference from Benchmark";

// Default heat weights in the settings
export const DEFAULT_HEAT_WEIGHTS = {
  slice: 100,
  time: 100,
  benchmark: 25,
};
